import styled from '@emotion/styled';
import type { State } from '../form.styles';
import { inputBaseStyles } from '../form.styles';

export const StyledTextArea = styled.textarea<{ state?: State }>`
  vertical-align: top;
  margin-top: 3px;
  width: 100%;
  max-width: 100%;
  height: 88px;
  resize: vertical;
  ${({ state }) => inputBaseStyles(state)}
`;
